import { Card, Checkbox, Col, Divider, Form, Input, Radio, Row } from 'antd';

export default function ServicesSection({
  isOtherChecked,
  setIsOtherChecked,
  isOtherSourceChecked,
  setIsOtherSourceChecked,
  businessWithForeignCountries,
  setBusinessWithForeignCountries,
  businessInActivitiesOtherThanPrimary,
  setBusinessInActivitiesOtherThanPrimary,
  qt,
}) {
  return (
    <>
      {/* Purpose and Intention */}
      <Card
        title={qt('questionnaire.purposeAndIntention')}
        className="mb-5"
        style={{ marginBottom: '20px' }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="accountingServices"
              valuePropName="checked"
              style={{ marginBottom: '10px' }}
            >
              <Checkbox>{qt('questionnaire.accountingServices')}</Checkbox>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="payrollProcessing"
              valuePropName="checked"
              style={{ marginBottom: '10px' }}
            >
              <Checkbox>{qt('questionnaire.payrollProcessing')}</Checkbox>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="isOtherChecked"
              valuePropName="checked"
              style={{ marginBottom: '10px' }}
            >
              <Checkbox onChange={(e) => setIsOtherChecked(e.target.checked)}>
                {qt('questionnaire.other')}
              </Checkbox>
            </Form.Item>
          </Col>

          {isOtherChecked && (
            <Col span={24}>
              <Form.Item
                name="otherServices"
                label={qt('questionnaire.specifyOther')}
                style={{ marginBottom: '10px' }}
              >
                <Input.TextArea rows={2} />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Card>

      {/* Source of Client Funds */}
      <Card
        title={qt('questionnaire.sourceOfClientFunds')}
        className="mb-5"
        style={{ marginBottom: '20px' }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="generatedFromBusinessActivities"
              valuePropName="checked"
              style={{ marginBottom: '10px' }}
            >
              <Checkbox>
                {qt('questionnaire.generatedFromBusinessActivities')}
              </Checkbox>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="donationsAndSponsorships"
              valuePropName="checked"
              style={{ marginBottom: '10px' }}
            >
              <Checkbox>
                {qt('questionnaire.donationsAndSponsorships')}
              </Checkbox>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="isOtherSourceChecked"
              valuePropName="checked"
              style={{ marginBottom: '10px' }}
            >
              <Checkbox
                onChange={(e) => setIsOtherSourceChecked(e.target.checked)}
              >
                {qt('questionnaire.other')}
              </Checkbox>
            </Form.Item>
          </Col>

          {isOtherSourceChecked && (
            <Col span={24}>
              <Form.Item
                name="otherDonationsAndSponsorships"
                label={qt('questionnaire.specifyOtherDonationsAndSponsorships')}
                style={{ marginBottom: '10px' }}
              >
                <Input.TextArea rows={2} />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Card>

      {/* Additional Business Information */}
      <Card
        title={qt('questionnaire.additionalBusinessInformationClient')}
        className="mb-5"
        style={{ marginBottom: '20px' }}
      >
        <Form.Item
          label={qt('questionnaire.pleaseIndicate')}
          style={{ marginBottom: '10px' }}
        >
          <Radio.Group
            onChange={(e) => setBusinessWithForeignCountries(e.target.value)}
            value={businessWithForeignCountries}
          >
            <Radio value={true}>{qt('questionnaire.yes')}</Radio>
            <Radio value={false}>{qt('questionnaire.no')}</Radio>
          </Radio.Group>
        </Form.Item>

        {businessWithForeignCountries && (
          <Form.Item
            name="businessWithForeignCountriesSpecification"
            label={qt('questionnaire.specifyCountryCountries')}
            style={{ marginBottom: '10px' }}
          >
            <Input.TextArea rows={2} />
          </Form.Item>
        )}

        <Divider />

        <Form.Item
          label={qt('questionnaire.pleaseIndicateWhether')}
          style={{ marginBottom: '10px' }}
        >
          <Radio.Group
            onChange={(e) =>
              setBusinessInActivitiesOtherThanPrimary(e.target.value)
            }
            value={businessInActivitiesOtherThanPrimary}
          >
            <Radio value={true}>{qt('questionnaire.yes')}</Radio>
            <Radio value={false}>{qt('questionnaire.no')}</Radio>
          </Radio.Group>
        </Form.Item>

        {businessInActivitiesOtherThanPrimary && (
          <Form.Item
            name="businessInActivitiesOtherThanPrimarySpecification"
            label={qt('questionnaire.specifyActivities')}
            style={{ marginBottom: '10px' }}
          >
            <Input.TextArea rows={2} />
          </Form.Item>
        )}
      </Card>
    </>
  );
}
